export enum TypeUtilisateurEnum {

    UTILISATEUR,
    GROUPE_UTILISATEUR,
    UTILISATEUR_IN_GROUPE
}
